import { useNavigate } from "react-router-dom";
import { usePropertyId } from "../../../../../common/hooks/usePropertyId";
import TableCalendars from "./TableCalendars";
import { withMultipleQueryData } from "../../../../../common/withQueryData";
import { useRoomsData } from "../../../../../common/hooks/useRoomsData";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";
import { OrdinaryButton } from "../../../../../common/Buttons";
import { Box, Typography } from "@mui/material";

const CalendarPage = () => {
    const propertyId = usePropertyId();

    const { queryResults: roomsQueryResults } = useRoomsData(propertyId);
    const { queryResults: plansQueryResults } = usePlansData(propertyId);

    return <TableCalendarswrapperWithMultipleQueryData
        queryResults={{
            rooms: roomsQueryResults,
            plans: plansQueryResults
        }}
        propertyId={propertyId}
    />
}

const TableCalendarsWrapper = ({ queryResults, reloadAll, ...props }) => {
    const navigate = useNavigate();

    const { rooms: roomsQueryResults, plans: plansQueryResults } = queryResults;

    /* eslint-disable no-unused-vars */
    const { data: rooms, refetch: reloadRooms } = roomsQueryResults;
    const { data: plans, refetch: reloadPlans } = plansQueryResults;
    /* eslint-enable no-unused-vars */

    const goToRoomsPage = () => {
        navigate('../../rooms');
    }

    const goToPlansPage = () => {
        navigate('../rate-plans');
    }

    const roomsMissing = !rooms?.length;
    const plansMissing = !plans?.length

    if (roomsMissing || plansMissing) {
        return <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
            variant="h6"
            component="div"
            sx={{ margin: '20px', textAlign: 'center' }}
        >
            Create at least one room and one rate plan in order to see the calendar
        </Typography>
        <OrdinaryButton sx={{ width: '300px', height: '50px', alignSelf: 'center' }} onClick={roomsMissing ? goToRoomsPage : goToPlansPage} text={`Go to ${roomsMissing ? 'Rooms' : 'Plans'}`} />
    </Box>;
    }

    return <TableCalendars rooms={rooms} plans={plans} {...props} />
}

const TableCalendarswrapperWithMultipleQueryData = withMultipleQueryData(TableCalendarsWrapper);

export default CalendarPage;